import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import CardView from "../../components/common/CardView";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import PageTitle from "../../components/pageTitle/PageTitle";
import ManageEmailTemplate from "../components/Communication/ManageEmailTemplate";
import DeletePopup from "../components/Communication/DeletePopup";
import { setNotificationAction } from "../../store/reducers/mmymSlice";
import ManageSendEmailTemplate from "../components/Communication/ManageSendEmailTemplate";
import {
  getAllEmailTemplatesAction,
  getLeadStageWithPlaceholdersAction,
} from "../../store/reducers/emailTemplateSlice";

const SuperAdminEmailTemplate = () => {
  const dispatch = useDispatch();

  const {
    allEmailTemplates,
    isAddEmailTemplateSuccess,
    leadStageWithPlaceholders,
  } = useSelector((state: any) => state.emailTemplates);

  useEffect(() => {
    if (dispatch) {
      dispatch(getAllEmailTemplatesAction({lead_stage:null}));
      dispatch(setNotificationAction({ message: [], severity: "error" }));
      dispatch(getLeadStageWithPlaceholdersAction());
    }
  }, [dispatch]);

  useEffect(() => {
    if (isAddEmailTemplateSuccess) {
      dispatch(getAllEmailTemplatesAction({lead_stage:null}));
    }
  }, [dispatch, isAddEmailTemplateSuccess]);

 
  const [open, setOpen] = useState(false);

  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const [sendModelShow, setSendModelShow] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    setSelectedRow(null);
  };


  const handleClose = () => {
    setOpen(false);
    setDeleteModelShow(false);
    setSendModelShow(false);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };
  const handleEditTemplate = (item: any, category: string) => {
    // Implement your edit functionality here
    console.log("Editing template with ID:", item);
    setSelectedRow({ ...item, category });
    setOpen(true);
    // You can open your edit modal or navigate to edit page here
  };

  const [value, setValue] = useState("");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleDeleteTemplate = (item: any) => {
    setDeleteModelShow(true);
    setSelectedRow(item);
  };

  const handleSendTemplate = (item: any) => {
    console.log("Send template with ID:", item);
    setSelectedRow(item);
    setSendModelShow(true);
  };
  const filteredTemplates = (allEmailTemplates || []).filter(
    (x: any) => x?.lead_stage === value,
  );
  console.log("allEmailTemplates", allEmailTemplates);

  const sortedStages = useMemo(() => {
  return [...(leadStageWithPlaceholders || [])].sort(
    (a: any, b: any) => a.stage_order - b.stage_order
  );
}, [leadStageWithPlaceholders]);

  useEffect(() => {
    if (!sortedStages.length) return;

    const hasSelectedStage = sortedStages.some((stage: any) => stage.stage === value);
    if (!hasSelectedStage) {
      setValue(sortedStages[0].stage);
    }
  }, [sortedStages, value]);

  return (
    <>
      {deleteModelShow && (
        <DeletePopup
          deleteModalShow={deleteModelShow}
          onHide={handleClose}
          deleteRec={selectedRow}
          setDeleteModalShow={setDeleteModelShow}
        />
      )}
      {open && (
        <ManageEmailTemplate
          selectTemplate={selectedRow}
          setSelectedRow={setSelectedRow}
          open={open}
          onHide={handleClose}
          title={selectedRow ? "Edit Email Template" : "Add Email Template"}
          screenType={value === "0" ? "ADMIN" : "CLIENT"}
        />
      )}
      {sendModelShow && (
        <ManageSendEmailTemplate
          selectTemplate={selectedRow}
          setSelectedRow={setSelectedRow}
          open={sendModelShow}
          onHide={handleClose}
          title={"Send Email Template"}
          screenType={value === "0" ? "ADMIN" : "CLIENT"}
        />
      )}
      <Grid
        container
        rowSpacing={1}
        // columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{
          background: "#f4f4f4",
          height: "auto",
          padding: "10px",
          // flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box
          // fixed={true}
          sx={{
            bgcolor: "#fff",
            padding: "20px 0px",
            border: "1px solid #d1cfcf",
            borderRadius: "5px",
            height: "fit-content",
            width: "100%",
          }}
        >
          <PageTitle
            title="Communication Template"
            button="Add Communication Template"
            onClick={handleOpen}
          />

          <Grid
            container
            // wrap="nowrap"
            spacing={2}
            sx={{
              flexDirection: { xs: "column", md: "row" },
              marginTop: "10px",
              padding: "16px 20px",
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
              style={{ padding: "0px 10px", marginBottom: "10px" }}
            >
              <Tabs
                // centered
                value={value}
                onChange={handleChange}
                textColor="secondary"
                indicatorColor="secondary"
                aria-label="secondary tabs example"
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                sx={{
                  background: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  marginBottom: "16px",
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                  minWidth: 0,
                  '& .MuiTabs-flexContainer': {
                    flexWrap: 'nowrap',
                  },
                }}
              >
                {sortedStages.map((stage: any) => (
                  <Tab
                    key={stage.stage}
                    value={stage.stage}
                    label={stage.description==='Lead Created' ? 'New Lead' : stage.description}
                    sx={{ minWidth: 120 }}
                  />
                ))}
              </Tabs>
            </Grid>

            {filteredTemplates.length > 0 ? (
              filteredTemplates?.map((item: any, i: number) => {
                const isAdminTemplate = item?.template_from === "client";
                return(
                <Grid key={i} item xs={12} sm={6} md={4} lg={3}>
                  <Box
                    sx={{
                      height: "100%",
                      borderRadius: "12px",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                      },
                    }}
                  >
                    <CardView
                      {...{
                        ...item,
                        isEdit: isAdminTemplate,
                        isDelete: isAdminTemplate,
                        isSend: true,
                        width: "100%",
                        onEditClick: () => handleEditTemplate(item, "admin"),
                        onDeleteClick: () => handleDeleteTemplate(item),
                        onSendClick: () => handleSendTemplate(item),
                      }}
                    />
                  </Box>
                </Grid>
              )})
            ) : (
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "300px",
                    border: "1px dashed #ccc",
                    borderRadius: "12px",
                    backgroundColor: "#fafafa",
                    textAlign: "center",
                    p: 3,
                  }}
                >
                  {/* Icon */}
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      borderRadius: "50%",
                      backgroundColor: "#e0f2f1",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    📧
                  </Box>

                  {/* Title */}
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: "#333", mb: 1 }}
                  >
                    No Email Templates Found
                  </Typography>

                  {/* Subtitle */}
                  <Typography
                    variant="body2"
                    sx={{ color: "#777", maxWidth: "300px", mb: 2 }}
                  >
                    You haven't created any email templates yet. Start by
                    creating a new template.
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
          {/* </Box> */}
        </Box>
      </Grid>
    </>
  );
};
export default SuperAdminEmailTemplate;
